import { Sparkles, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAiAssistant } from '@/contexts/AiAssistantContext';

/**
 * The minimised assistant: a pill in the bottom-right corner (the notes dock
 * owns the bottom-left). Clicking it brings the conversation back exactly as
 * it was.
 */
export function AiAssistantDock() {
  const { t } = useTranslation();
  const { state, open, close } = useAiAssistant();
  if (state !== 'minimized') return null;

  return (
    <div data-ai-dock className="fixed bottom-4 right-4 z-[140] flex items-center">
      {/* Two real buttons side by side — a control nested inside a button is
          unreachable for assistive tech. */}
      <div className="flex items-center gap-1 rounded-full border border-border bg-card py-1 pl-3 pr-1 text-xs font-medium shadow-lg">
        <button
          type="button"
          onClick={open}
          className="flex items-center gap-2 rounded-full py-1 transition-colors hover:text-primary"
        >
          <Sparkles size={14} className="text-primary" />
          <span>{t('ai.title')}</span>
        </button>
        <button
          type="button"
          aria-label={t('ai.close')}
          onClick={close}
          className="rounded-full p-1 text-muted-foreground transition-colors hover:bg-background hover:text-foreground"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
